export const BOOKING_GATEWAY = `https://${process.env.REACT_APP_BOOK_API_DOMAIN_NAME}`;
export const APPOINTMENTS_GATEWAY = `https://${process.env.REACT_APP_APPOINTMENT_SERVICE_DOMAIN_NAME}`;

// Website GraphQL API (same endpoint the website uses, POST to the root path).
// REACT_APP_WEBSITE_API_URL comes from the tenant config's existing
// WEBSITE_API_URL key: a domain only, no scheme, the same host global-website
// uses for NEXT_PUBLIC_WEBSITE_API_URL. Read lazily so a missing or blank value
// turns the feature off instead of producing a request to "https://undefined/".
export const getWebsiteApiUrl = (): string | null => {
  const domain = process.env.REACT_APP_WEBSITE_API_URL?.trim();
  // A JSON null/undefined in the tenant config file reaches the build as the
  // literal string "null"/"undefined", so those count as unset too.
  if (!domain || domain === 'undefined' || domain === 'null') return null;
  return `https://${domain}/`;
};

// The flight booking UI demo (/flight-demo) is an allowlist: GWAT tenant AND
// the tenant config ENVIRONMENT being exactly 'development'. An unset or any
// other value (live, staging, ...) keeps it off. Unlike getEnv() this ignores
// NODE_ENV, so `npm run live` keeps it off too.
export const isFlightDemoEnabled = (): boolean =>
  (process.env.REACT_APP_TENANT || 'gwat') === 'gwat' &&
  process.env.REACT_APP_ENVIRONMENT === 'development';
